<template>
  <div class="main-container">
    <AppMain></AppMain>
  </div>
</template>

<script>
import AppMain from './components/AppMain'
export default {
  name: 'Layout',
  components: { AppMain },
  data() {
    return {
    }
  },
  methods: {
  },
  computed: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Layout/ReaderLayout.vue